const EsporaiVideo = () => {
  return (
    <video
      className="absolute inset-0 w-full h-full object-cover"
      autoPlay
      loop
      muted
      playsInline
    >
      <source
        src="https://www.espor.ai/images/hero-gif.mp4"
        type="video/mp4"
      />
    </video>
  );
}

export default EsporaiVideo;